import { get, reduce, isMatch } from 'lodash'
import FONIX_ERRORS from './fonix'
import PAYPAL_ERRORS from './paypal'
import { STRIPE_ERRORS, STRIPE_ERRORS_EXTRA } from './stripe'
import GENERIC_ERRORS from './generic'
import VALIDATION_ERRORS from './validation'

export const ENTRY_DETAILS_ERROR_TYPE = {
  PAYMENT: 'payment',
  GENERIC: 'generic'
}

export const errorEntryGetDetails = failReason => {
  const fonix = FONIX_ERRORS[failReason]
  const paypal = PAYPAL_ERRORS[failReason]
  const stripe = STRIPE_ERRORS[failReason]
  const stripeExtra = STRIPE_ERRORS_EXTRA[failReason]
  const generic = GENERIC_ERRORS[failReason]
  if (fonix || paypal || stripe) {
    return {
      type: ENTRY_DETAILS_ERROR_TYPE.PAYMENT,
      message: fonix || paypal || stripe,
      messageExtra: stripeExtra || null
    }
  } else if (generic) {
    return {
      type: ENTRY_DETAILS_ERROR_TYPE.GENERIC,
      message: generic
    }
  }
  return {
    type: ENTRY_DETAILS_ERROR_TYPE.GENERIC,
    message: 'Ohh no, we are sorry but we failed to process your entry.'
  }
}

export const errorResponseHandler = error => {
  const errorMessage = get(error, 'message', null)
  const errorResponseStatus = get(error, 'response.status', null)
  const errorResponseMessage = get(error, 'response.data.message', null)
  const errorResponseDetails = get(error, 'response.data.details', {})

  let validation = []

  switch (errorResponseStatus) {
    case 400: {
      // console.log('BAD REQUEST')
      break
    }
    case 422:
      validation = reduce(
        errorResponseDetails,
        (result, value, key) => {
          value.forEach(v => {
            result.push(VALIDATION_ERRORS?.[key]?.[v] || `${key} ${v}`)
          })
          return result
        },
        []
      )
  }
  return {
    isBadRequest: (key, value) => {
      if (errorResponseStatus === 400) {
        if (key && value) {
          return isMatch(errorResponseDetails, { [key]: [value] })
        }
        return true
      }
      return false
    },
    isUnauthorized: () => errorResponseStatus === 401,
    isValidation: () => errorResponseStatus === 422,
    isTooManyRequests: () => errorResponseStatus === 429,
    isNetworkError: () => errorMessage === 'Network Error',
    code: errorResponseStatus,
    type: errorResponseMessage,
    details: errorResponseDetails,
    validation
  }
}
